import React, { useContext, useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import moment from 'moment'
import { useParams } from 'react-router-dom'

import Loading from '../../components/Loading'

import { ATENDIMENTOS_API_URL } from '../../constants/api'
import { FirebaseContext, CurrentUserContext } from '../../Contexts'
import { useCallbackStatic } from '../../hooks/utils'

// const characterLimit = 240;

const Base = (props) => {
  const {
    title,
    description,
    imagePath,
    programName,
    satisfacao,
    comentarios,
    nome,
    telefone,
    email,
    clearForm
  } = props

  const queryParameters = new URLSearchParams(window.location.search)
  const salesForceCaseId = queryParameters.get('idCasoSalesForce')

  const { firebaseAuth } = useContext(FirebaseContext)
  const { currentUser } = useContext(CurrentUserContext)
  const [userIdToken, setUserIdToken] = useState('')
  const [loading, setLoading] = useState(true)
  const [result, setResult] = useState(false)
  const [hasError, setHasError] = useState(undefined)

  useEffect(() => {
    const getFirebaseToken = async () => {
      if (firebaseAuth.currentUser) {
        const token = await firebaseAuth.currentUser.getIdToken()
        setUserIdToken((_) => token)

        const url = `${ATENDIMENTOS_API_URL}/avaliacao/${salesForceCaseId}`
        const result = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })
        const response = result.data

        if (response.valid) {
          setLoading(false)
        } else {
          setHasError('Avaliação já realizada')
        }

      } else {
        setHasError('Usuário não autenticado')
      }
    }
    getFirebaseToken()
  }, [firebaseAuth.currentUser])

  const back = useCallbackStatic(() => {
    setResult(false)
  })

  const send = useCallbackStatic(async (data) => {
    setLoading(true)

    if (currentUser.podeEnviarMensagens) {
      const token = await firebaseAuth.currentUser.getIdToken()
      const url = `${ATENDIMENTOS_API_URL}/avaliacao`
      const headers = { Authorization: `Bearer ${token}` }
      const body = {
        salesForceCaseId,
        satisfacao: data.satisfacao,
        comentarios: data.comentarios
      }

      await axios.post(url, body, { headers })
    }

    clearForm()
    setResult(true)
    setLoading(false)
  })

  const sendMessage = useCallback(() => {
    if (!salesForceCaseId) {
      alert('Atendimento inválido')
      return
    }

    if (!satisfacao || satisfacao.length <= 0) {
      alert('Escolha seu nível de satisfação')
      return
    }

    // if (!comentarios || comentarios.length <= 0) {
    //   alert('Escreva um comentário')
    //   return
    // }

    send({
      salesForceCaseId,
      satisfacao,
      comentarios,
      nome,
      telefone,
      email
    })
  }, [salesForceCaseId, satisfacao, comentarios, nome, telefone, email])

  const renderError = useCallback(
    () => (
      <div className="container">
        <div className="titenquete">{title}</div>
        <div className="descenquete">
          {hasError}
        </div>
      </div>
    ),
    [hasError, title]
  )

  const renderContent = useCallback(() => {
    if (!result) {
      return (
        <div className="container">
          <div className="titenquete">{title}</div>
          <div className="descenquete">{description()}</div>

          <div className="btsalvar">
            <button onClick={sendMessage}>Enviar</button>
          </div>
        </div>
      )
    }
    return (
      <div className="container">
        <div className="titenquete">Avaliação enviada com sucesso!</div>
      </div>
    )
  }, [back, description, result, sendMessage, title])

  return (
    <React.Fragment>
      <div className="enqueterpc">
        {hasError ? renderError() : loading ? <Loading /> : renderContent()}
      </div>
    </React.Fragment>
  )
}

export default Base
